import React from 'react';
import { useTranslation } from 'react-i18next';

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-16">
      {/* --- Banner bo‘limi --- */}
      <section
        className="relative h-64 bg-cover bg-center"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50" />
        <div className="relative container mx-auto h-full flex items-center justify-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
            {t('services.title', 'Xizmatlarimiz')}
          </h1>
        </div>
      </section>

      {/* --- Asosiy xizmatlar bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-etmgreen text-center mb-8">
            {t('services.primaryTitle', 'Biz taklif etadigan asosiy xizmatlar')}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Xizmat 1 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🖥️</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.installationTitle', 'Ishga tushirish va konfiguratsiya')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.installationText',
                  'Onlayn NKT larini joyiga o‘rnatish, dasturiy ta’minotni sozlash va birinchi ishga tushirish.'
                )}
              </p>
            </div>
            {/* Xizmat 2 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🔧</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.maintenanceTitle', 'Texnik xizmat ko‘rsatish')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.maintenanceText',
                  'Oylik texnik va dasturiy qo‘llab - quvvatlash'
                )}
              </p>
            </div>
            {/* Xizmat 3 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🎓</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.trainingTitle', 'Xodimlarni o‘qitish')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.trainingText',
                  'Onlayn NKT lardan maksimal manfaat olish uchun xodimlarga malakali trening va qo‘llanmalar berib borish.'
                )}
              </p>
            </div>
            {/* Xizmat 4 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">📱</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.mobileIntegrationTitle', 'Mobil integratsiya')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.mobileIntegrationText',
                  'Smartfon va planshet uchun mobil kassa ilovalarini sozlash, 4G/5G tarmoqlarida ishlash imkoniyati.'
                )}
              </p>
            </div>
            {/* Xizmat 5 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🔒</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.securityTitle', 'Xavfsizlik va himoya')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.securityText',
                  'Ma’lumotlarni shifrlash, tizimni yangilash va kirish nazoratini o‘rnatish orqali ma’lumotlaringiz xavfsizligi.'
                )}
              </p>
            </div>
            {/* Xizmat 6 */}
            <div className="bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
              <div className="flex items-center justify-center h-16 w-16 bg-etmgreen text-white rounded-full mb-4 mx-auto">
                <span className="text-2xl">🖨️</span>
              </div>
              <h3 className="text-xl font-semibold text-center mb-2">
                {t('services.cloudReportsTitle', 'Onlayn NKT larga qo‘shimcha qurilmalarni ulash')}
              </h3>
              <p className="text-gray-600 text-sm text-center">
                {t(
                  'services.cloudReportsText',
                  'Skaner, Printer va boshqa qurilmalarni ulash va konfiguratsiyalash'
                )}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Xizmatlar va narxlar bo‘limi --- */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-etmgreen text-center mb-8">
            {t('services.pricingTitle', 'Xizmatlar va narxlar')}
          </h2>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-lg shadow">
              <thead>
                <tr className="bg-etmgreen text-white">
                  <th className="py-3 px-6 text-left">{t('services.tableHeaderService', 'Xizmat')}</th>
                  <th className="py-3 px-6 text-left">{t('services.tableHeaderDescription', 'Tavsif')}</th>
                  <th className="py-3 px-6 text-left">{t('services.tableHeaderPrice', 'Narx (UZS)')}</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b hover:bg-gray-100 transition">
                  <td className="py-4 px-6">{t('services.installationTitle', 'Ishga tushirish va konfiguratsiya')}</td>
                  <td className="py-4 px-6">{t('services.installationText', 'Fiskal Modulni (FM) faollashtirish va dasturiy sozlash')}</td>
                  <td className="py-4 px-6">155,000</td>
                </tr>
                <tr className="border-b hover:bg-gray-100 transition">
                  <td className="py-4 px-6">{t('services.maintenanceTitle', 'Texnik xizmat ko‘rsatish')}</td>
                  <td className="py-4 px-6">{t('services.maintenanceText', 'Oylik texnik va dasturiy ko‘mak')}</td>
                  <td className="py-4 px-6">75,000 - 100,000/ oy</td>
                </tr>
                <tr className="border-b hover:bg-gray-100 transition">
                  <td className="py-4 px-6">{t('services.cloudReportsTitle', 'O‘qitish')}</td>
                  <td className="py-4 px-6">{t('services.cloudReportsText', '3 kun muddatda Onlayn NKT ni ishlatishni o‘rgatish')}</td>
                  <td className="py-4 px-6">250,000</td>
                </tr>
                <tr className="border-b hover:bg-gray-100 transition">
                  <td className="py-4 px-6">{t('services.mobileIntegrationTitle', 'Onlayn NKT ni ro‘yxatdan chiqarish')}</td>
                  <td className="py-4 px-6">{t('services.mobileIntegrationText', 'Onlayn NKT ni Soliq qo‘mitasidan ro‘yxatdan chiqarish')}</td>
                  <td className="py-4 px-6">75,000</td>
                </tr>
                <tr className="hover:bg-gray-100 transition">
                  <td className="py-4 px-6">{t('services.trainingTitle', 'FM ni almashttirish va faollashtirish')}</td>
                  <td className="py-4 px-6">{t('services.trainingText', 'Yangi FM o‘rnatish va faollashtirish')}</td>
                  <td className="py-4 px-6">150,000</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* --- Qo‘llab-quvvatlash va tezkor yordam bo‘limi --- */}
      <section className="bg-white py-16">
        <div className="container mx-auto px-4 md:flex md:items-center md:space-x-8">
          <div className="md:w-1/2 space-y-6">
            <h2 className="text-3xl font-bold text-etmgreen">
              {t('services.supportTitle', 'Qo‘llab-quvvatlash')}
            </h2>
            <p className="text-gray-700 leading-relaxed">
              {t(
                'services.supportText',
                'Bizning 24/7 texnik qo‘llab-quvvatlash xizmati har doim siz bilan. Telefon, elektron pochta orqali tezkor yordam olasiz.'
              )}
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>{t('services.supportBullet1', 'Telefon: +998 93 315 99 39, +998 90 611 72 43')}</li>
              <li>{t('services.supportBullet2', 'Email: info@navoietm.uz')}</li>
            </ul>
          </div>
          <div className="md:w-1/2 mt-8 md:mt-0">
            <img
              src="https://plus.unsplash.com/premium_photo-1658506646178-e4ef5810361b?q=80&w=2072&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Qo‘llab-quvvatlash"
              className="w-full rounded-lg shadow-lg object-cover h-64 md:h-80"
            />
          </div>
        </div>
      </section>

      {/* --- CTA bo‘limi --- */}
      <section className="bg-gradient-to-r from-etmgreen to-sky text-white py-16">
        <div className="container mx-auto px-4 text-center space-y-6">
          <h2 className="text-3xl font-bold">
            {t('services.ctaTitle', 'Bugun biz bilan bog‘laning va yechimni tanlang!')}
          </h2>
          <p className="text-lg">
            {t(
              'services.ctaText',
              'Sifatli xizmatlarimiz va raqobatbardosh narxlarimiz orqali biznesingizni yangi darajaga olib chiqing.'
            )}
          </p>
          <a
            href="/Contact"
            className="inline-block bg-white text-etmgreen font-semibold py-3 px-8 rounded-full hover:bg-gray-100 transition"
          >
            {t('services.ctaButton', 'Aloqa')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
